import React, { Component } from 'react';
import moment from 'moment';
import _ from 'lodash';
import CN from 'classnames';
import { Icon } from 'elements';

import './ConversationPreview.css';


export default class ConversationPreview extends Component {

  static propTypes = {
    conversation: React.PropTypes.object,
    history: React.PropTypes.object,
    displayEmail: React.PropTypes.bool
  };

  state = {
    conversation: this.props.conversation
  };

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  render() {
    const { participant, message, read, uuid, readByRecipient } = this.state.conversation;
    const _notReadByRecipient = !readByRecipient && message;

    let msgText;
    if (message) {
      if (message.text.length > 30) {
        msgText = message.text.substr(0, 30) + '...';
      } else {
        msgText = message.text;
      }
    }

    return (
      <div
        className={ CN('conversation-preview', { 'unread-thread': !read }, { 'read-thread': read }) }
        onClick={ () => this.props.history.push(`/conversation/${uuid}`) }
      >
        <div >
          <span className={ CN('unread-thread-dot', { 'invisible-dot': read }) } >&#9679;</span >
          <span
            className="msg-participant" >{ participant.name } { this.props.displayEmail && participant.email }</span >
          { message &&
          <span
            className="float-right msg-datetime"
          >
            {
              message.payed &&
              <span className="payed-sign-conv" >$</span >
            }
            { _notReadByRecipient &&
            <span className="unread-by-recipient" >not read by recipient </span >
            }
            { !read &&
            <span className="new-message-sign" >new message </span >
            }
            { (read && (message.sender === participant.uuid)) &&
            <span className="unanswered-question-sign" >unanswered question </span >
            }
            {
              moment(message.createdAt).format('MMM DD, YYYY h:mm A')
            }
            </span >
          }

        </div >
        <div >
          { message && <span className="msg-text" >{ msgText }</span > }
        </div >
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/elements/conversation-preview/ConversationPreview.jsx